var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 scale-50 pointer-events-none select-none"})
}
var staticRenderFns = []

export { render, staticRenderFns }